import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Props } from '../InlineView';
import DeviationMediaService from '../../../utils/DeviationMediaService';

const ImageInlineView: React.FC<Props> = ({
  deviation,
  width: propWidth,
  height: propHeight,
  crop = 'fill',
}: Props) => {
  const { t } = useTranslation();
  const thumb = useMemo(() => {
    return DeviationMediaService.getSmallestThumbThatFullyCovers(
      deviation,
      propWidth,
      propHeight ?? Infinity,
      th => th[th.length - 1], // Take largest if nothing covers,
      {
        thumbTypes: ['375W', '414W', '750W', '828W'],
      }
    );
  }, [deviation, propHeight, propWidth]);

  if (!thumb) {
    return <span>{t('editor.inlineView.failedToRender')}</span>;
  }

  return (
    <img
      loading="lazy"
      src={thumb.src}
      alt={deviation.title}
      width={Math.min(thumb.width ?? Infinity, propWidth)}
      height={Math.min(thumb.height ?? Infinity, propHeight ?? Infinity)}
      style={{ objectFit: crop, verticalAlign: 'bottom' }}
    />
  );
};
ImageInlineView.displayName = 'ImageInlineView';

export default ImageInlineView;
